import axios from 'axios'

export default () => {
  return axios.create({
    baseURL: 'https://application.sadcseedcentre.com/api/web/v1/'
  })
}



// WEBPACK FOOTER //
// ./src/services/Api.js